var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module",
    attrs: {
      "data-test": "outside-vif"
    }
  }, [_c('div', {
    staticClass: "messages status sds-assigned-msg"
  }, [_c('ul', [_c('li', [_vm._v("SDS assigned to container " + _vm._s(_vm.getContainerId()))])])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("SDS Information")]), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Title: ")]), _vm._v("\n        " + _vm._s(_vm.getSdsTitle()) + "\n      ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Source: ")]), _vm._v("\n        " + _vm._s(_vm.getSdsSource()) + "\n      ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "raftjs-entity-view-label"
  }, [_vm._v("Origin: ")]), _vm._v("\n        " + _vm._s(_vm.getSdsOrigin()) + "\n      ")])], 1)], 1), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.chemContainersCount))]), _vm._v(" other containers of this\n    chemical were found. The container already assigned to this SDS is\n    excluded. Select and filter results below to assign this SDS to additional\n    chemical containers.\n  ")]), _vm._v(" "), _vm.foundContainers ? _c('fieldset', {
    staticClass: "sds-attachments-filters"
  }, [_c('legend', [_vm._v("Filters")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline my-2 my-lg-0"
  }, [_c('div', {
    staticClass: "form-group sds-attachment-filter-wrapper"
  }, [_c('label', {
    attrs: {
      "for": "chemical-container-filter-synonym"
    }
  }, [_vm._v("Chemical Name:")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "text",
      "id": "chemical-container-filter-synonym",
      "name": "chemical-container-filter-synonym",
      "aria-label": "Filter by preferred chemical name",
      "size": "sm",
      "maxlength": "255",
      "placeholder": "Filter by chemical name"
    },
    model: {
      value: _vm.sdsChemicalNameFilter,
      callback: function ($$v) {
        _vm.sdsChemicalNameFilter = $$v;
      },
      expression: "sdsChemicalNameFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group sds-attachment-filter-wrapper"
  }, [_c('label', {
    attrs: {
      "for": "chemical-container-filter-manufacturer"
    }
  }, [_vm._v("Manufacturer:")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "text",
      "id": "chemical-container-filter-manufacturer",
      "name": "chemical-container-filter-manufacturer",
      "aria-label": "Filter by manufacturer",
      "size": "sm",
      "maxlength": "255",
      "placeholder": "Filter by manufacturer"
    },
    model: {
      value: _vm.sdsChemicalManufacturerFilter,
      callback: function ($$v) {
        _vm.sdsChemicalManufacturerFilter = $$v;
      },
      expression: "sdsChemicalManufacturerFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group sds-attachment-filter-wrapper"
  }, [_c('label', {
    attrs: {
      "for": "chemical-container-filter-product"
    }
  }, [_vm._v("Product Name:")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "text",
      "id": "chemical-container-filter-product",
      "name": "chemical-container-filter-product",
      "aria-label": "Filter by product",
      "size": "sm",
      "maxlength": "255",
      "placeholder": "Filter by product"
    },
    model: {
      value: _vm.sdsChemicalProductFilter,
      callback: function ($$v) {
        _vm.sdsChemicalProductFilter = $$v;
      },
      expression: "sdsChemicalProductFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group sds-attachment-filter-wrapper"
  }, [_c('label', {
    attrs: {
      "for": "chemical-container-filter-prod-number"
    }
  }, [_vm._v("Product Number:")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "type": "text",
      "id": "chemical-container-filter-prod-number",
      "name": "chemical-container-filter-prod-number",
      "aria-label": "Filter by product number",
      "size": "sm",
      "maxlength": "255",
      "placeholder": "Filter by a product number"
    },
    model: {
      value: _vm.sdsProductNumberFilter,
      callback: function ($$v) {
        _vm.sdsProductNumberFilter = $$v;
      },
      expression: "sdsProductNumberFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sds-attachment-filter-button-wrapper"
  }, [_c('button', {
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.getChemicalContainers.apply(null, arguments);
      }
    }
  }, [_vm._v("Apply")])])])]) : _vm._e(), _vm._v(" "), _c('b-table', {
    ref: "chemContainersTable",
    class: {
      'table-pause-scroll': _vm.isBusy || _vm.chemContainers.length < 1
    },
    attrs: {
      "striped": "",
      "hover": "",
      "sticky-header": true,
      "no-local-sorting": true,
      "show-empty": "",
      "busy": _vm.isBusy,
      "fields": _vm.fields,
      "items": _vm.chemContainers
    },
    scopedSlots: _vm._u([{
      key: "head(selected)",
      fn: function (data) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.allSelected,
            expression: "allSelected"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : _vm.allSelected
          },
          on: {
            "change": function ($event) {
              var $$a = _vm.allSelected,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.allSelected = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.allSelected = $$c;
              }
            }
          }
        })];
      }
    }, {
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-danger my-2"
        }, [_vm.$isB4 ? _c('div', {
          staticClass: "loading-throbber"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1) : _c('div', [_c('img', {
          attrs: {
            "src": "/sites/all/modules/hide_submit/images/squares.gif",
            "alt": "loading"
          }
        })]), _vm._v(" "), _c('strong', [_vm._v("Loading matching chemical containers...")])])];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "chemtracker-empty-text"
        }, [_vm._v("\n        " + _vm._s(_vm.emptyText) + "\n      ")])];
      },
      proxy: true
    }, {
      key: "cell(selected)",
      fn: function (row) {
        var _row$item, _row$item2;
        return [_c('b-form-checkbox', {
          attrs: {
            "id": 'chemical-container-' + (row === null || row === void 0 ? void 0 : (_row$item = row.item) === null || _row$item === void 0 ? void 0 : _row$item.id),
            "value": row === null || row === void 0 ? void 0 : (_row$item2 = row.item) === null || _row$item2 === void 0 ? void 0 : _row$item2.id,
            "checked": _vm.allSelected
          },
          nativeOn: {
            "click": function ($event) {
              $event.stopPropagation();
            }
          },
          model: {
            value: _vm.selectedChemicalContainers,
            callback: function ($$v) {
              _vm.selectedChemicalContainers = $$v;
            },
            expression: "selectedChemicalContainers"
          }
        })];
      }
    }])
  }, [_vm._v(">\n\n    ")]), _vm._v(" "), !_vm.hideControls ? _c('div', {
    staticClass: "sds-attachments-dialog-controls"
  }, [_vm.chemContainersCount > 0 ? _c('button', {
    attrs: {
      "id": "bulk-assign-btn",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": _vm.sdsBulkAssign
    }
  }, [_vm._v("\n      Bulk Assign\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Exit")])]) : _vm._e(), _vm._v(" "), _vm.hideControls ? _c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_vm.$isB4 ? _c('div', {
    staticClass: "loading-throbber"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  })], 1) : _c('div', [_c('img', {
    attrs: {
      "src": "/sites/all/modules/hide_submit/images/squares.gif",
      "alt": "loading"
    }
  })])]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }